import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/map';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { MatButtonModule, MatCheckboxModule, MatPaginatorIntl } from '@angular/material';
import { Sort } from '@angular/material';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { MatIconModule } from '@angular/material';
import { PageEvent } from '@angular/material';
import { ViewChild } from '@angular/core';
import { MatFormFieldModule } from '@angular/material';
import { MatInputModule } from '@angular/material';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Subject } from 'rxjs/Subject';
import { ParInsuranceService } from '../../../services/par_insurance/par-insurance.service';
import { InsuranceDocsClearDialogComponent } from '../../insurance-docs-clear-dialog/insurance-docs-clear-dialog.component';
import { ParInsuranceDialogueComponent } from '../par-insurance-dialogue/par-insurance-dialogue.component';
import * as moment from 'moment';



@Component({
  selector: 'app-par-insurance-document',
  templateUrl: './par-insurance-document.component.html',
  styleUrls: ['./par-insurance-document.component.css']
})


export class ParInsuranceDocumentComponent implements OnInit {
  clientDisable: any;
  clientHidden: any;
  public role: string;
  refresh = new Subject();
  doctype;
  agentName: string;
  agentId;
  agentDetails;
  pageSize = 10;
  insurancedocs = [];
  agentdoctype = [];
  dataSource: MatTableDataSource<UserData>;
  displayedColumns = ['DocumentTypeName', 'FileName', 'ExpirationDate', 'UploadedDate', 'FileEdit'];
  message: string;
  sortedData;
  data: boolean = true;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  length: number;
  ispaginationFlag: boolean;
  noResults: string;
  docCategory: any;
  errorMessage: String = '';
  errorEnable: boolean = false;
  uploadedFileName;
  placeholder = "Select a Document"
  parinsdata: Array<any> = [];
  pardoctype: any;
  constructor(private http: Http, private router: Router, private parinsuranceservice: ParInsuranceService, public dialog: MatDialog) {
  }


  pageEvent: PageEvent;

  ngOnInit() {
    this.uploadedFileName = 'PAR Insurance - PAR North America';
    this.parinsuranceservice.insurancedoctypeget().subscribe(res => {
      this.pardoctype = res.DocumentTypes;
      this.docCategory = this.pardoctype[0].Category;
    }, error => {
      this.errorMessage = "Par insurence document types: " + error;
      this.errorEnable = true
    })

    this.parinsuranceservice.load.subscribe(res => {
      if (res === 'success') {
        this.doctype = null;
        this.getDetails();
      }
    });

    this.role = localStorage.getItem("Role")
    if (this.role === "PC Client") {
      this.clientDisable = true;
      this.clientHidden = true;
    } else {
      this.clientDisable = false;
      this.clientHidden = false;
    }
    this.getDetails();
  }

  placeholderChange() {
    this.placeholder = "Document"
  }

  getDetails() {

    this.parinsuranceservice.parinsuranceDocGet().subscribe(res => {
      if (res.InsuranceDetails.length <= 0 || res.InsuranceDetails === undefined) {
        this.parinsdata = [];
        this.ispaginationFlag = false;
        this.dataSource = null;
        this.message = "No documents found";
      }
      else {
        this.parinsdata = res.InsuranceDetails;
        this.message = '';
        this.data = true;
        for (let i = 0; i < this.parinsdata.length; i++) {
          if (this.parinsdata[i].UploadedDate != '' && this.parinsdata[i].UploadedDate != null && this.parinsdata[i].UploadedDate != undefined) {
            var momentDate = moment(this.parinsdata[i].UploadedDate).format('YYYY/MM/DD');
            this.parinsdata[i].UploadedDate = momentDate;
          }
          if (this.parinsdata[i].ExpirationDate !== '' && this.parinsdata[i].ExpirationDate !== null && this.parinsdata[i].ExpirationDate !== undefined) {
            var momentDate = moment(this.parinsdata[i].ExpirationDate).format('YYYY/MM/DD');
            this.parinsdata[i].ExpirationDate = momentDate;
          }
        }
        this.dataSource = new MatTableDataSource(this.parinsdata);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.length = this.parinsdata.length;
        if (this.length <= 10) {
          this.ispaginationFlag = false;
        }
        else {
          this.ispaginationFlag = true;
        }
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        const paginatorIntl = new MatPaginatorIntl();
        paginatorIntl.itemsPerPageLabel = 'Items per page';
        paginatorIntl.nextPageLabel = 'Next page';
        paginatorIntl.previousPageLabel = 'Previous page';
        paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
          length = this.length;
          if (length == 0 || pageSize == 0) { return `0 van ${length}`; }
          length = Math.max(length, 0);
          const startIndex = page * pageSize;
          // If the start index exceeds the list length, do not try and fix the end index to the end.
          const endIndex = startIndex < length ?
            Math.min(startIndex + pageSize, length) :
            startIndex + pageSize;
          const round = Math.ceil(length / 10)
          return `${(startIndex / 10) + 1}  of ${round}`;
        }
        this.dataSource.paginator._intl = paginatorIntl;
      }
    }, error => {
      this.errorMessage = "Par insurance all documents: " + error;
      this.errorEnable = true;
    }
    )
  }
  getColor(expirationDate) {
    let todayDate = new Date()
    let currentDate = new Date().setHours(0, 0, 0, 0);
    var targetDate = new Date();
    let futureDate = targetDate.setDate(todayDate.getDate() + 30);
    let future = new Date(futureDate).setHours(0, 0, 0, 0);
    let expDate = new Date(expirationDate).setHours(0, 0, 0, 0);
    if (expDate < currentDate) {
      return "red";
    }
    else if (expDate > future) {
      return "black";
    }
    else {
      return "blue";
    }
  }
  clear(data, type?) {
    data.DocumentCategory = this.docCategory;
    let dialogRef = this.dialog.open(InsuranceDocsClearDialogComponent, {
      width: '400px',
      height: '200px',
      data: { 'data': data, 'type': 'parinsurance' }
    });
  }
  openDialog(name, type, id?): void {
    let code = null;
    code = this.pardoctype.find(doc => doc.DocumentTypeName === name).DocumentTypeCode;
    var new_Data = {
      DocumentTypeName: name,
      _id: id,
      DocumentTypeCode: code,
      DocumentCategory: this.docCategory
    };
    var Data;
    if (this.parinsdata.length > 0) {
      for (let i = 0; i < this.parinsdata.length; i++) {
        if (this.parinsdata[i]._id === id) {
          Data = this.parinsdata[i]
        }
      }
    }
    let dialogRef = this.dialog.open(ParInsuranceDialogueComponent, {
      width: '1000px',
      height: '600px',
      data: { data: type === 'update' ? Data : new_Data, type: type, Category: this.docCategory }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.doctype = null;
      this.placeholder = 'Select a Document'
    });
  }

  doctypechange(doc) {
    this.openDialog(doc, 'create');
  }

  fileEdit(docName, id, ) {
    this.openDialog(docName, 'update', id);
  }
}

export interface UserData {
  DocumentTypeName: String;
  FileName: String;
  ExpirationDate: Date;
  UploadedDate: Date;
  FileEdit: any;
}



// WEBPACK FOOTER //
// ./src/app/components/par-insurance/par-insurance-document/par-insurance-document.component.ts